import { render } from "./HowToMeasure.vue?vue&type=template&id=64559c28"
import script from "./HowToMeasure.vue?vue&type=script&lang=js"
export * from "./HowToMeasure.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__